import { setMapData, setMapDataFailed, setMapDataLoading } from '../../actions/map';
import { notify } from '../../actions/notifications';
import { IGetMapDataResponseSchema } from '../../repositories/favorites/entities/user_folder/GetMapDataResponseSchema';
import {
  fetchWebGetMapData,
  IWebGetMapDataRequest,
  TWebGetMapDataResponse,
} from '../../repositories/favorites/v1/web/get-map-data';
import { ENotificationStyle } from '../../types/notifications';
import { TThunkAction } from '../../types/redux';

export const getMapData =
  (parameters: IWebGetMapDataRequest): TThunkAction<Promise<void>> =>
  async (dispatch, getState, { httpApi, logger }) => {
    const showError = () => dispatch(notify('Не получилось загрузить данные карты', ENotificationStyle.Error));

    dispatch(setMapDataLoading());

    try {
      const { statusCode, response }: TWebGetMapDataResponse = await fetchWebGetMapData({ httpApi, parameters });

      if (statusCode === 200) {
        dispatch(setMapData(response as IGetMapDataResponseSchema));
      }

      if (statusCode === 400) {
        logger.warning(response.message || 'Failed to get map data by folder (400 status code)');
        dispatch(setMapDataFailed());
        showError();
      }
    } catch (e) {
      logger.error(e, { description: 'Failed to get map data by folder' });
      dispatch(setMapDataFailed());
      showError();
    }
  };
